<template>
  <div style="height: 100%;">
    <div  v-if="!$store.state.isFalse" class="loginContent">
      <div class="loginBox">
        <!--      <div class="avatar_Box">-->
        <!--        <img src="../assets/logo.png" alt />-->
        <!--      </div>-->
        <div style="padding:40px;display: flex;justify-content: center;align-items: center">
          <img src="../assets/13.svg" alt />
        </div>
        <div class="loginA">
          <el-form :label-position="labelPosition" :model="formLabelAlign">
            <el-form-item>
              <el-input v-model="formLabelAlign.username" placeholder="用户名："></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="password" v-model="formLabelAlign.password" placeholder="密码："></el-input>
            </el-form-item>
            <el-form-item>
              <el-col :span="9">
                <el-input
                  v-model="formLabelAlign.vfcode"
                  maxlength="4"
                  minlength="4"
                  class="loginWord"
                  placeholder="请输入验证码"
                  @keyup.enter.native.prevent="submitForm()"
                ></el-input>
              </el-col>
              <el-col :span="9">
                <img :src="verifyImg" @click="refVfcode" width="150" height="40" class="c_vf" />
              </el-col>
              <el-col :span="6" style="text-align: right">
                <span style="color:#C1C5CD;margin-left:8px;font-size:14px;line-height: 40px;">点击更新</span>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm()"
                class="login_btn"
                style="letter-spacing: 2px;"
              >登录</el-button>
              <!--              <el-link :underline="false" class="findPwd">找回密码?</el-link>-->
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>
    <div class="main" v-else>
      <fails404></fails404>
    </div>
  </div>
</template>
<script>
import { setAuth } from '../util/auth'
import { deepClone } from '@/util'
import { encode64 } from '@/util/tool'
import http from '@/util/http'
import Fails404 from '@/views/fails404'
export default {
  name: 'LoginView',
  components: { Fails404 },
  data () {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        username: '',
        password: '',
        vfcode: ''
      },
      verifyUrl: '/api/verifyCode.jpg',
      verifyImg: ''
    }
  },
  created () {
    this.verifyImg = this.verifyUrl + '?d=' + new Date().getTime()
    this.getVaildateImage()
    /** 兼容IE下面 回车提交生效**/
    const that = this
    document.onkeydown = function () {
      const key = window.event.keyCode
      if (key === '13') {
        that.submitForm()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.refVfcode()
    }, 100)
  },
  methods: {
    getVaildateImage() {
      const { verifyImg } = this
      http({
        url: verifyImg,
        method: 'get'
      }).then(res => {
      }).catch(err => {
        console.log(err)
        this.$store.state.isFalse = true
      })
    },
    async submitForm () {
      // 登录请检查
      // await this.$post('/api/auth/check', this.formLabelAlign)
      const { formLabelAlign } = this
      const { password } = formLabelAlign
      //
      await this.$post('/api/auth/check/v2', Object.assign(deepClone(formLabelAlign), {
        password: encode64(password)
      }))
        .then(res => {
          if (res.code === 70000) {
            const user = JSON.stringify(res.obj)
            // 保存参数
            setAuth(user)
            this.$router.push('/workbench/workbenchManage/home')
          } else if (res.code !== 70000) {
            this.$message.error(res.msg)
            this.refVfcode()
            this.formLabelAlign.vfcode = ''
          }
        })
        .catch(err => {
          console.log('login.vue error:' + err)
        })
    },
    refVfcode () {
      this.verifyImg = this.verifyUrl + '?d=' + new Date().getTime()
    }
  }
}
</script>

<style lang="scss" scoped>
.loginContent {
  height: 100%;
  background-color: #0f5ee9;
  background-image: url("../assets/img/login_bg.svg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
.loginBox {
  background-color: #ffffff;
  width: 460px;
  position: absolute;
  top: 43%;
  right: 15%;
  transform: translate(0, -50%);

  box-shadow: 0px 2px 10px 3px rgba(4, 90, 231, 0.62);
  border-radius: 4px;
  img {
    height: 40px;
  }
}
.loginBox .avatar_Box {
  height: 90px;
  width: 90px;
  border-radius: 50%;
  border: 1px solid #eee;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
.loginBox .avatar_Box img {
  width: 100px;
  height: 100%;
  background-color: #eee;
  border-radius: 50%;
}
.loginA {
  box-sizing: border-box;
  padding: 10px 40px;
  margin-top: 10px;
  overflow: hidden;
  input {
    height: 40px;
  }
}
.loginWord {
  letter-spacing: 10px;
}
.c_vf {
  margin-left: 12px;
  margin-right: 5px;
  border-radius: 3px;
}
.findPwd {
  margin-left: 10px;
  font-size: 12px;
}
.el-form-item {
  margin-bottom: 36px;
}

.el-input ::v-deep .el-input__inner {
  height: 40px;
  padding-top: 2px;
}

.el-input ::v-deep .el-input__inner::placeholder {
  font-size: 14px;
  line-height: 40px;
}

.el-form-item ::v-deep .el-form-item__label {
  height: 28px;
  line-height: 28px;
}

.el-form-item ::v-deep .el-form-item__content {
  line-height: 28px;
}
.login_btn {
  width: 100%;
  line-height: 44px;
  height: 58px;
  background: #276cff;
  border-radius: 4px;
  font-size: 18px;
  margin-bottom: 30px;
}
</style>
